<template>
  <v-dialog
    :value="show"
    :fullscreen="false"
    content-class="force-no-margins-dialog"
    :width="dialogWidth"
    lazy
    @input="(val) => $emit('update:show', val)"
  >
    <!-- Note:

			  The v-if makes sure that the video element is only part of the
			  DOM when needed, as e.g. Edge chokes on a larger number of
			  video tags until it freezes. However, medialementjs behaves
			  rather poorly when trying to "restart" its player, so try to
			  avoid changing anything that affects the current
			  implementation.

			  Also added a fade-transition since otherwise the dialog would
			  vanish immediately as its content gets removed by the v-if.

      -->
    <v-fade-transition>
      <v-card
        v-if="show"
        :style="{overflow: 'hidden'}"
      >
        <div :style="{height: dialogHeight + 'px'}">
          <mini-preview-video-player
            :video-url="previewUrl"
            :poster-url="posterUrl"
            :width="dialogWidth"
            :height="dialogHeight"
          />
        </div>
      </v-card>
    </v-fade-transition>
  </v-dialog>
</template>

<script>
import 'mediaelement/build/mediaelement-and-player.min.js';

import MiniPreviewVideoPlayer from '@/components/MiniPreviewVideoPlayer';

export default {
  components: {
    MiniPreviewVideoPlayer,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    dialogWidth: {
      type: Number,
      required: true,
    },
    dialogHeight: {
      type: Number,
      required: true,
    },
    previewUrl: {
      type: String,
      required: true,
    },
    posterUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      player: null,
    };
  },
};
</script>

<style>
.v-dialog--active.force-no-margins-dialog {
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/MiniPreviewVideoDialog.vue